module.exports = "https://web-assets.ifttt.com/packs/media/shared/icon-verified_service-d2d066da.svg";